import { Datetime, Select } from "components/shared/form";
import { formatDateForDocumentTag } from "helpers/date";
import { ymEvent } from "helpers/system";
import { requiredField } from "helpers/validators";
import moment from "moment";
import React, { useState } from "react";
import { alert } from "services/alert";
import { list } from "sources/books/documentTemplates";

const getMissingCounterpartyMessage = (target) =>
    target.missingCounterpartyMessage || "Для создания договора-заявки необходимо выбрать контрагента";

export default function CreateDocument(props) {
    const { cargoOwnerDictionaryItem, counterparty } = props;
    const targets = props.targets?.length
        ? props.targets
        : [
              {
                  key: "default",
                  counterparty: counterparty || cargoOwnerDictionaryItem,
                  action: props.action,
                  missingCounterpartyMessage: "Для создания договора-заявки необходимо выбрать контрагента для заявки",
              },
          ];
    const [loading, setLoading] = useState(false);
    const [documentDate, setDocumentDate] = useState(() => moment().format("YYYY-MM-DD"));
    const [documentTemplateIds, setDocumentTemplateIds] = useState({});
    const [selectedTargetKey, setSelectedTargetKey] = useState(targets.length === 1 ? targets[0].key : null);
    const selectedTarget = targets.find((target) => target.key === selectedTargetKey);
    const isTargetChoiceRequired = targets.length > 1;

    const handleCreate = (target) => {
        if (!target.counterparty) {
            return alert({ type: "warning", message: getMissingCounterpartyMessage(target), title: "Ошибка" });
        }

        const documentTemplateId = documentTemplateIds[target.key];
        if (!documentTemplateId) {
            return alert({ type: "warning", message: "Выберите шаблон договора", title: "Ошибка" });
        }
        ymEvent("CreateContract");
        setLoading(true);
        target
            .action({
                id: props.id,
                documentTemplateId,
                manualValues: {
                    documentDate: formatDateForDocumentTag(documentDate),
                },
            })
            .then((res) => {
                if (res) {
                    props.back();
                } else {
                    setLoading(false);
                }
            })
            .catch(() => {
                setLoading(false);
            });
    };

    const renderTargetForm = (target) => {
        const documentTemplateId = documentTemplateIds[target.key];
        const selectProps = {
            inputProps: { name: `documentTemplateId_${target.key}` },
            value: documentTemplateId,
            placeholder: "Выберите шаблон договора",
            url: (params) =>
                target.counterparty ? list({ ...params, counterpartyId: target.counterparty.id }) : Promise.resolve([]),
            propName: "name",
            onChange: ({ value }) => setDocumentTemplateIds((values) => ({ ...values, [target.key]: value })),
            menuPortalTarget: document.body,
            required: true,
            validators: [requiredField],
            disabled: !target.counterparty,
        };
        return (
            <div className="mb-3">
                {target.label && !isTargetChoiceRequired && <div className="font-weight-bold mb-2">{target.label}</div>}
                {!target.counterparty && (
                    <div className="alert alert-danger">{getMissingCounterpartyMessage(target)}</div>
                )}
                <Select key={target.key} {...selectProps} />
                <div className="btn btn-sm btn-brand btn-block" onClick={() => handleCreate(target)}>
                    {target.buttonText || "Создать договор"}
                </div>
            </div>
        );
    };

    const renderDocumentDate = () => {
        if (!props.documentDate) {
            return null;
        }

        return (
            <Datetime
                labelWrapper="col-12 col-form-label col-form-label-sm text-muted"
                wrapper="col-12"
                inPortal
                {...props.documentDate}
                value={documentDate}
                onChange={({ value }) => setDocumentDate(value)}
            />
        );
    };

    const targetSelectProps = {
        inputProps: { name: "documentTarget" },
        label: "С кем создается договор-заявка",
        value: selectedTargetKey,
        placeholder: "Выберите сторону договора",
        options: targets.map((target) => ({
            label: target.label || target.buttonText || "Контрагент",
            value: target.key,
        })),
        onChange: ({ value }) => setSelectedTargetKey(value),
        labelWrapper: "col-12 col-form-label col-form-label-sm text-muted",
        fieldWrapper: "col-12",
        menuPortalTarget: document.body,
        required: true,
        validators: [requiredField],
        unClearable: true,
    };

    return (
        <div className={loading ? "loading loading--small" : ""}>
            {renderDocumentDate()}
            {isTargetChoiceRequired && <Select {...targetSelectProps} />}
            {selectedTarget && renderTargetForm(selectedTarget)}
        </div>
    );
}
